"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePrice = exports.normalizePrice = void 0;

var _utils = require("./utils");

var normalizePrice = function normalizePrice(a, b) {
  if (a !== b) {
    return "".concat((0, _utils.formatMoney)(a), " - ").concat((0, _utils.formatMoney)(b));
  } else {
    return (0, _utils.formatMoney)(a);
  }
};

exports.normalizePrice = normalizePrice;

var usePrice = function usePrice(_ref) {
  var priceRange = _ref.priceRange;
  var _priceRange$minimum_p = priceRange.minimum_price,
      minFinalPrice = _priceRange$minimum_p.final_price,
      minRegulaPrice = _priceRange$minimum_p.regular_price,
      minMemberPrice = _priceRange$minimum_p.member_price,
      _priceRange$maximum_p = priceRange.maximum_price,
      maxFinalPrice = _priceRange$maximum_p.final_price,
      maxRegularPrice = _priceRange$maximum_p.regular_price,
      maxMemberPrice = _priceRange$maximum_p.member_price;
  var isSalePrice = minFinalPrice.value !== minRegulaPrice.value;
  var regularPrice = normalizePrice(minRegulaPrice.value, maxRegularPrice.value);
  var salePrice = normalizePrice(minFinalPrice.value, maxFinalPrice.value);
  var regularPriceValue = Math.min(minRegulaPrice.value, maxRegularPrice.value);
  var minPriceValue = Math.min(minRegulaPrice.value, minFinalPrice.value);
  var memberPriceValue = Math.min(minMemberPrice === null || minMemberPrice === void 0 ? void 0 : minMemberPrice.value, maxMemberPrice === null || maxMemberPrice === void 0 ? void 0 : maxMemberPrice.value);
  var memberPrice = normalizePrice(minMemberPrice === null || minMemberPrice === void 0 ? void 0 : minMemberPrice.value, maxMemberPrice === null || maxMemberPrice === void 0 ? void 0 : maxMemberPrice.value);
  var minPlpMemberPrice = Math.min(minFinalPrice.value, minMemberPrice === null || minMemberPrice === void 0 ? void 0 : minMemberPrice.value);
  var maxPlpMemberPrice = Math.max(maxFinalPrice.value, maxMemberPrice === null || maxMemberPrice === void 0 ? void 0 : maxMemberPrice.value);
  var plpMemberPrice = normalizePrice(minPlpMemberPrice, maxPlpMemberPrice);
  return {
    regularPrice: regularPrice,
    salePrice: salePrice,
    isSalePrice: isSalePrice,
    regularPriceValue: regularPriceValue,
    minPriceValue: minPriceValue,
    memberPriceValue: memberPriceValue,
    memberPrice: memberPrice,
    plpMemberPrice: plpMemberPrice
  };
};

exports.usePrice = usePrice;